module.exports = __webpack_public_path__ + "img/KubeOperator-red.5542eb5a.png";